import { STORE_CHANNELS } from 'helpers/constants/storeChannels';

// The commercetools project is shared with StairSupplies. A category is this storefront's only when
// one of its store roots is among its ancestors; anything else (other stores' trees, and the roots
// themselves) is not ours. Missing ancestor data counts as outside, so callers fail closed.
// Mirrors the backend's isWithinStoreRoot (commerce-commercetools CategoryRouter).
export const isStorefrontCategory = (category: { ancestorKeys?: string[] }): boolean =>
  (category.ancestorKeys ?? []).some((key) => (STORE_CHANNELS as readonly string[]).includes(key.toLowerCase()));
